import { render, staticRenderFns } from "./PaymentMain.vue?vue&type=template&id=05e16384&scoped=true&"
import script from "./PaymentMain.vue?vue&type=script&lang=js&"
export * from "./PaymentMain.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMain.vue?vue&type=style&index=0&id=05e16384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e16384",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VCard,VIcon,VList,VSlideGroup,VSlideItem})
